module.exports = __webpack_public_path__ + "img/attack_dragonhell.d8e3de31.png";